module.exports = __webpack_public_path__ + "media/img/event/job_header-9cde3ae384577dbc6f8a5d4bbaf3352c.png";